import { render, staticRenderFns } from "./work-orders-edit-form.html?vue&type=template&id=1a515131&scoped=true&"
import script from "./work-orders-edit-form.js?vue&type=script&lang=js&"
export * from "./work-orders-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a515131",
  null
  
)

export default component.exports